import { create } from "zustand";

type CatalogLanguageState = {
  selectedCatalogLanguage: string;
  setSelectedCatalogLanguage: (languageCode: string) => void;
};

const STORAGE_KEY = "catalog-language-state";

const loadSelectedCatalogLanguage = () => {
  try {
    const data = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
    return String(data?.selectedCatalogLanguage || "").trim().toLowerCase();
  } catch {
    return "";
  }
};

const persistSelectedCatalogLanguage = (selectedCatalogLanguage: string) => {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ selectedCatalogLanguage })
  );
};

export const useCatalogLanguageStore = create<CatalogLanguageState>((set) => ({
  selectedCatalogLanguage: loadSelectedCatalogLanguage(),
  setSelectedCatalogLanguage: (languageCode) => {
    const selectedCatalogLanguage = String(languageCode || "")
      .trim()
      .toLowerCase();
    set({ selectedCatalogLanguage });
    persistSelectedCatalogLanguage(selectedCatalogLanguage);
  },
}));
